<template>
    <b-modal size="xl"
             centered
             hide-footer
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal">
        <template v-slot:modal-title>
            <strong>
                <span v-if="!isEditing">新增服務</span>
                <span v-else>正在編輯《{{ service.name }}》</span>
            </strong>
        </template>

        <b-form v-on:submit.prevent="submit">
            <div class="form-row">
                <div class="col-lg-4 service-images-wrapper">
                    <div class="mb-3">
                        <b-form-group label="服務相片"
                                      label-for="servicePhoto">
                            <div class="position-relative service-images img-thumbnail bg-light"
                                 v-on:click="changePhoto">
                                <input id="servicePhoto"
                                       class="d-none"
                                       type="file"
                                       multiple
                                       v-on:change="updatePhoto">
                                <img alt="服務相片"
                                     class="w-100 h-100"
                                     v-if="photo.length > 0"
                                     v-bind:src="photo[0]">
                                <div class="d-flex justify-content-center align-items-center w-100 h-100"
                                     v-else>
                                    <h5 class="text-center font-weight-bold mb-0">
                                        點擊更新👆👆
                                    </h5>
                                </div>
                            </div>
                        </b-form-group>

                        <draggable class="thumbnails d-flex flex-wrap"
                                   v-model="photo">
                            <div class="thumbnail-wrapper pr-1 pb-1"
                                 v-for="aPhoto in photo"
                                 v-bind:key="aPhoto">
                                <img class="img-thumbnail h-100 w-100"
                                     alt="服務相片縮圖"
                                     v-bind:src="aPhoto">
                            </div>
                        </draggable>
                    </div>

                    <div>
                        <b-form-group label="服務品牌 (可選填)"
                                      label-for="serviceLogo">
                            <div class="position-relative logo-image img-thumbnail bg-light"
                                 v-on:click="changeLogo">
                                <input id="serviceLogo"
                                       class="d-none"
                                       type="file"
                                       v-on:change="updateLogo">
                                <img alt="服務品牌"
                                     class="w-100 h-100"
                                     v-if="logo"
                                     v-bind:src="logo">
                                <div class="d-flex justify-content-center align-items-center w-100 h-100"
                                     v-else>
                                    <h5 class="text-center font-weight-bold mb-0">
                                        點擊更新👆👆
                                    </h5>
                                </div>
                            </div>
                        </b-form-group>
                    </div>
                </div>

                <div class="col-lg-8">
                    <div class="form-row">
                        <b-form-group class="col-md-6"
                                      label-for="verification">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'eye']"></font-awesome-icon> 項目狀態
                            </template>
                            <div id="verification"
                                 class="btn-group btn-group-sm">
                                <button type="button"
                                        class="btn border-right-0"
                                        v-bind:class="{ 'btn-success': !hidden, 'btn-outline-success': hidden, 'font-weight-bolder': !hidden }"
                                        v-on:click="hidden = false">
                                    可見
                                </button>
                                <button type="button"
                                        class="btn border-left-0"
                                        v-bind:class="{ 'btn-danger': hidden, 'btn-outline-danger': !hidden, 'font-weight-bolder': hidden }"
                                        v-on:click="hidden = true">
                                    隱藏
                                </button>
                            </div>
                        </b-form-group>

                        <b-form-group class="col-md-6"
                                      label-for="status"
                                      v-if="['vending-admin'].includes(userRole)">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'clipboard-check']"></font-awesome-icon> 審核狀態
                            </template>
                            <div id="status"
                                 class="btn-group btn-group-sm">
                                <button type="button"
                                        class="btn border-right-0"
                                        v-bind:class="{ 'btn-success': approved, 'btn-outline-success': !approved, 'font-weight-bolder': approved }"
                                        v-on:click="approved = true">
                                    已獲批準
                                </button>
                                <button type="button"
                                        class="btn border-left-0"
                                        v-bind:class="{ 'btn-danger': !approved, 'btn-outline-danger': approved, 'font-weight-bolder': !approved }"
                                        v-on:click="approved = false">
                                    待批準
                                </button>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="form-row">
                        <b-form-group class="col-md-12"
                                      label-for="name">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'heading']"></font-awesome-icon> 服務名稱
                            </template>
                            <b-form-input id="name"
                                          class="bg-light"
                                          type="text"
                                          required
                                          v-model="name">
                            </b-form-input>
                        </b-form-group>
                    </div>

                    <div class="form-row">
                        <b-form-group class="col-md-6"
                                      label-for="category"
                                      label="服務分類">
                            <template v-slot:label>
                                <font-awesome-icon class="mr-2"
                                                   v-bind:icon="['fad', 'tags']">
                                </font-awesome-icon>
                                <span class="mr-2">服務分類</span>
                                <button class="btn btn-sm btn-link"
                                        v-if="['vending-admin'].includes(userRole)"
                                        v-on:click.prevent.stop="isModalCategoriesOpen = true">
                                    管理分類
                                </button>
                            </template>
                            <b-form-select id="category"
                                           class="bg-light"
                                           required
                                           v-model="category">
                                <b-form-select-option v-for="{ _id, name } in categories"
                                                      v-bind:key="_id"
                                                      v-bind:value="_id">
                                    {{ name | capitalize }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group class="col-md-12"
                                      label-for="description">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'info-square']"></font-awesome-icon> 服務描述 (可選填)
                            </template>
                            <b-form-textarea id="description"
                                             class="bg-light"
                                             rows="4"
                                             v-model="description">
                            </b-form-textarea>
                        </b-form-group>

                        <b-form-group class="col-md-12"
                                      label-for="size">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'ruler-combined']"></font-awesome-icon> 尺寸 (可選填)
                            </template>
                            <b-form-textarea id="size"
                                             class="bg-light"
                                             rows="2"
                                             v-model="size">
                            </b-form-textarea>
                        </b-form-group>
                    </div>

                    <hr v-if="['vending-admin'].includes(userRole)">

                    <div class="form-row"
                         v-if="['vending-admin'].includes(userRole)">
                        <b-form-group class="col-lg-8 col-xl-6"
                                      label-for="provider">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'warehouse-alt']"></font-awesome-icon> 服務提供者
                            </template>
                            <v-select id="provider"
                                      class="bg-light"
                                      label="name"
                                      v-bind:options="vendors"
                                      v-model="owner">
                                <template v-slot:search="{ attributes, events }">
                                    <input class="vs__search"
                                           v-bind:required="!owner"
                                           v-bind="attributes"
                                           v-on="events">
                                </template>
                                <template v-slot:option="{ role, name, email, avatar }">
                                    <div class="d-flex align-items-center">
                                        <div class="mr-2">
                                            <b-avatar size="2.5em"
                                                      variant="light"
                                                      v-bind:src="avatar ? `${ $config.apiUrl }/${ $config.apiVersion }/user/avatar/${ avatar }`: ''">
                                                <font-awesome-icon class="h-100 w-100 p-3"
                                                                   icon="user-tie"
                                                                   v-if="!avatar && role === 'vending-admin'">
                                                </font-awesome-icon>
                                                <font-awesome-icon class="h-100 w-100 p-3"
                                                                   icon="user-hard-hat"
                                                                   v-if="!avatar && role === 'vending-site-manager'">
                                                </font-awesome-icon>
                                            </b-avatar>
                                        </div>
                                        <div class="flex-grow-1">
                                            <h6 class="font-weight-bold mb-0">
                                                {{ name }}
                                            </h6>
                                            <p class="mb-0">
                                                <small>
                                                    {{ email }}
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:selected-option="{ role, name, email, avatar }">
                                    <div class="d-flex align-items-center">
                                        <div class="mr-2">
                                            <b-avatar size="2.5em"
                                                      variant="light"
                                                      v-bind:src="avatar ? `${ $config.apiUrl }/${ $config.apiVersion }/user/avatar/${ avatar }`: ''">
                                                <font-awesome-icon class="h-100 w-100 p-3"
                                                                   icon="user-tie"
                                                                   v-if="!avatar && role === 'vending-admin'">
                                                </font-awesome-icon>
                                                <font-awesome-icon class="h-100 w-100 p-3"
                                                                   icon="user-hard-hat"
                                                                   v-if="!avatar && role === 'vending-site-manager'">
                                                </font-awesome-icon>
                                            </b-avatar>
                                        </div>
                                        <div class="flex-grow-1">
                                            <h6 class="font-weight-bold mb-0">
                                                {{ name }}
                                            </h6>
                                            <p class="mb-0">
                                                <small>
                                                    {{ email }}
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </b-form-group>
                    </div>

                    <div class="form-row">
                        <div class="col-md-12 d-flex align-items-center mb-2">
                            <div class="flex-grow-1">
                                <b-form-group class="mb-0"
                                              label-for="skuSettings">
                                    <template v-slot:label>
                                        <font-awesome-icon v-bind:icon="['fad', 'cubes']"></font-awesome-icon> SKU設定
                                    </template>
                                    <b-form-checkbox id="skuSettings"
                                                     switch
                                                     size="lg"
                                                     v-model="isMultipleSKU">
                                        <small>
                                            <span v-if="isMultipleSKU">多個SKU</span>
                                            <span v-else>單一SKU</span>
                                        </small>
                                    </b-form-checkbox>
                                </b-form-group>
                            </div>
                            <div>
                                <button class="btn btn-light border"
                                        v-if="isMultipleSKU"
                                        v-on:click="addSku">
                                    <font-awesome-icon class="mr-2"
                                                       icon="plus-square">
                                    </font-awesome-icon>新增SKU
                                </button>
                            </div>
                        </div>

                        <div class="col-12 form-row bg-light border rounded pt-2 mb-3">
                            <s-k-u-card class="col-md-6"
                                        v-for="({ _id }, index) in sku"
                                        v-bind:key="_id || index"
                                        v-bind:index="_id || index"
                                        v-model="sku[index]">
                            </s-k-u-card>
                        </div>
                    </div>

                    <div class="form-row"
                         v-if="['vending-admin'].includes(userRole)">
                        <b-form-group class="col-md-12"
                                      label-for="rebate">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'money-check-edit-alt']"></font-awesome-icon> 回饋分成 (可選填)
                            </template>
                            <b-form-textarea id="rebate"
                                             class="bg-light"
                                             rows="2"
                                             v-model="rebate">
                            </b-form-textarea>
                        </b-form-group>

                        <b-form-group class="col-lg-8 col-xl-6"
                                      label-for="contractPeriod">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'calendar-alt']"></font-awesome-icon> 合作期限 (可選填)
                            </template>
                            <b-form-input id="contractPeriod"
                                          type="text"
                                          class="bg-light"
                                          v-model="contractPeriod">
                            </b-form-input>
                        </b-form-group>
                    </div>

                    <div class="form-row">

                    </div>
                </div>
            </div>

            <div class="text-center mt-3">
                <button class="btn font-weight-bolder px-4"
                        type="submit"
                        v-bind:class="{ 'btn-success': !isEditing, 'btn-warning': isEditing, 'btn-loading': isLoading }">
                    {{ isEditing? "✏️ 編輯" : "🆕 新增" }}
                </button>
            </div>
        </b-form>

        <modal-categories v-if="['vending-admin'].includes(userRole)"
                          v-model="isModalCategoriesOpen">
        </modal-categories>
    </b-modal>
</template>

<script>
import {
    BModal,
    BAvatar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import draggable from "vuedraggable";
import ModalCategories from "./ModalCategories";
import SKUCard from "./ModalService/SKUCard";

export default {
    name: "ModalService",
    components: {
        "v-select": vSelect,
        SKUCard,
        BModal,
        BAvatar,
        BForm,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BFormSelect,
        BFormSelectOption,
        BFormCheckbox,
        draggable,
        ModalCategories,
    },
    props: {
        "value": {
            type: Boolean,
        },

        "isEditing": {
            type: Boolean,
            default: false,
        },

        "service": {
            type: Object,
        },
    },
    data () {
        return {
            isModalCategoriesOpen: false,
            isMultipleSKU: false,
            isLoading: false,

            approved: false,
            hidden: true,
            order: 0,
            owner: null,

            category: null,
            size: "",
            rebate: "",
            contractPeriod: "",
            description: "",

            logo: "",
            logoFile: null,

            photo: [],
            photoFiles: [],

            productCode: "",
            sku: [{
                "code": "",
                "name": "",
            }],
        };
    },
    computed: {
        userRole () {
            return this.$store.state.user.user.role;
        },

        users () {
            return this.$store.getters["users/all"];
        },

        vendors () {
            return this.users
                .filter(
                    ({ role }) => ["vending-vendor"].includes(role)
                );
        },

        categories () {
            return this.$store.state.data.categories;
        },
    },
    methods: {
        hideModal () {
            this.$emit("input", false);
        },

        addSku () {
            this.sku.push(
                {
                    "code": "",
                    "name": "",
                }
            );
        },

        reset () {
            this.approved = false;
            this.hidden = true;
            this.order = 0;
            this.owner = null;

            this.name = "";
            this.category = null;
            this.size = "";
            this.rebate = "";
            this.contractPeriod = "";
            this.description = "";

            this.logo = "";
            this.logoFile = null;

            this.photo = [];
            this.photoFiles = [];

            this.productCode = "";
            this.sku = [{
                "code": "",
                "name": "",
            }];
        },

        changePhoto () {
            document
                .getElementById("servicePhoto")
                .click();
        },

        changeLogo () {
            document
                .getElementById("serviceLogo")
                .click();
        },

        async updatePhoto (e) {
            const temp = Array.from(e.target.files || e.dataTransfer.files);
            if (temp.length === 0) {
                return;
            }
            this.photoFiles = temp;
            this.photo = await Promise.all(
                this.photoFiles.map(
                    file => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        return new Promise(
                            (resolve) => {
                                reader.onload = (e) => {
                                    resolve(e.target.result);
                                };
                            }
                        );
                    }
                )
            );
        },

        async updateLogo (e) {
            console.log(e.target.files || e.dataTransfer.files);
            const temp = Array.from(e.target.files || e.dataTransfer.files);
            if (temp.length === 0) {
                return;
            }
            this.logoFile = temp;
            this.logo = await Promise.all(
                this.logoFile.map(
                    file => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        return new Promise(
                            (resolve) => {
                                reader.onload = (e) => {
                                    resolve(e.target.result);
                                };
                            }
                        );
                    }
                )
            );
        },

        submit () {
            if (this.isEditing) {
                this.editService();
                return;
            }
            this.addService();
        },

        async addService () {
            this.isLoading = true;
            const payload = {
                approved: this.userRole === "vending-admin" ? this.approved : undefined,
                hidden: this.hidden,
                order: this.order,

                name: this.name,
                category: this.category,
                size: this.size,
                rebate: this.rebate,
                contractPeriod: this.contractPeriod,
                description: this.description,

                photo: this.photoFiles,

                productCode: this.productCode,
                sku: this.sku,
            };

            if (this.owner) {
                payload.owner = this.owner._id;
            }

            if (
                Array.isArray(this.logoFile) &&
                this.logoFile.length > 0
            ) {
                payload.logo = this.logoFile[0];
            }

            try {
                await this.$store.dispatch(
                    "data/addService",
                    payload
                );
            } catch (e) {
                console.error(e);
                this.isLoading = false;
                return;
            }
            this.isLoading = false;
            this.reset();
            this.hideModal();
        },

        async editService () {
            this.isLoading = true;
            const payload = {
                _id: this.service._id,

                approved: this.userRole === "vending-admin" ? this.approved : undefined,
                hidden: this.hidden,
                order: this.order,

                name: this.name,
                category: this.category,
                size: this.size,
                rebate: this.rebate,
                contractPeriod: this.contractPeriod,
                description: this.description,

                photo: this.photoFiles,

                productCode: this.productCode,
                sku: this.sku,
            };

            if (this.owner) {
                payload.owner = this.owner._id;
            }

            if (
                Array.isArray(this.logoFile) &&
                this.logoFile.length > 0
            ) {
                payload.logo = this.logoFile[0];
            }

            try {
                await this.$store.dispatch(
                    "data/editService",
                    payload
                );
            } catch (e) {
                console.error(e);
                this.isLoading = false;
                return;
            }
            this.isLoading = false;
            this.hideModal();
        },
    },
    mounted () {
        if (this.service) {
            this.approved = this.service.approved;
            this.hidden = this.service.hidden;
            this.order = this.service.order;
            this.owner = this.service.owner;

            this.name = this.service.name;
            this.category = this.service.category._id;
            this.size = this.service.size;
            this.rebate = this.service.rebate;
            this.contractPeriod = this.service.contractPeriod;
            this.description = this.service.description;

            if (this.service.logo !== undefined) {
                this.logo = `${ this.$config.apiUrl }/${ this.$config.apiVersion }/service/image/${ this.service.logo }`;
            }
            this.photo = this.service.photo
                .map(
                    photo => `${ this.$config.apiUrl }/${ this.$config.apiVersion }/service/image/${ photo }`
                );

            if (
                Array.isArray(this.service.sku) &&
                this.service.sku.length > 0
            ) {
                this.isMultipleSKU = this.service.sku.length > 1;
                this.sku = this.service.sku;
            } else {
                this.isMultipleSKU = false;
                this.sku = [{
                    "code": "",
                    "name": "",
                }];
            }
        }
    },
    watch: {
        "service" (newVal) {
            if (newVal) {
                this.approved = newVal.approved;
                this.hidden = newVal.hidden;
                this.order = newVal.order;
                this.owner = newVal.owner;

                this.name = newVal.name;
                this.category = newVal.category._id;
                this.size = newVal.size;
                this.rebate = newVal.rebate;
                this.contractPeriod = newVal.contractPeriod;
                this.description = newVal.description;

                if (newVal.logo !== undefined) {
                    this.logo = `${ this.$config.apiUrl }/${ this.$config.apiVersion }/service/image/${ newVal.logo }`;
                }
                this.photo = newVal.photo
                    .map(
                        photo => `${ this.$config.apiUrl }/${ this.$config.apiVersion }/service/image/${ photo }`
                    );

                if (
                    Array.isArray(newVal.sku) &&
                    newVal.sku.length > 0
                ) {
                    this.isMultipleSKU = this.service.sku.length > 1;
                    this.sku = newVal.sku;
                } else {
                    this.isMultipleSKU = false;
                    this.sku = [{
                        "code": "",
                        "name": "",
                    }];
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../../node_modules/bootstrap/scss/functions";
@import "../../../node_modules/bootstrap/scss/variables";
@import "../../../node_modules/bootstrap/scss/mixins/breakpoints";

.service-images-wrapper {
    .logo-image,
    .service-images {
        height: 200px;

        & > img {
            object-fit: contain;
        }

        &:hover,
        &:focus {
            &:after {
                display: flex;
                justify-content: center;
                align-items: center;

                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;

                color: rgba(255, 255, 255, 1);
                background-color: rgba(0, 0, 0, 0.25);

                font-size: 2rem;
                font-weight: bolder;

                cursor: pointer;
            }
        }
    }

    .service-images {
        &:hover,
        &:focus {
            &:after {
                content: "編輯服務相片";
            }
        }
    }

    .logo-image {
        &:hover,
        &:focus {
            &:after {
                content: "編輯服務品牌";
            }
        }
    }

    .thumbnails {
        .thumbnail-wrapper {
            height: 90px;
            width: 25%;

            @include media-breakpoint-up(lg) {
                width: 33.33%;
            }

            @include media-breakpoint-up(xl) {
                width: 25%;
            }

            & > .img-thumbnail {
                object-fit: contain;
            }
        }
    }
}
</style>
